export default "<p *ngFor=\"let item of this.list\">* {{item.body}}</p>\n";